import { livescoreHeaderTokens, oddsTokens, pillTabsTokens } from './general-components';

export const tennisAthleteProgrammeTokens = {
  ...oddsTokens,
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
  rowBackgroundColor: '',
  primaryBackgroundColor: '',
  pillBackgroundColor: '',
  pillActiveBackgroundColor: '',
  dropdownBtnColor: '',
  standingsLinkColor: '',
  scoreAccentColor: '',
};

export const tennisTournamentProgrammeTokens = {
  ...oddsTokens,
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
  rowBackgroundColor: '',
  primaryBackgroundColor: '',
  pillBackgroundColor: '',
  pillActiveBackgroundColor: '',
  dropdownBtnColor: '',
  standingsLinkColor: '',
  scoreAccentColor: '',
};

export const tennisLivescoreTokens = {
  ...livescoreHeaderTokens,
  ...oddsTokens,
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
  rowBackgroundColor: '',
  filtersContainerPrimaryBackgroundColor: '',
  standingsLinkColor: '',
  scoreAccentColor: '',
};

export const tennisPlayoffTokens = {
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
  rowBackgroundColor: '',
  statusBadgeBgColor: '',
  statusBadgeTextColor: '',
  knockoutBgColor: '',
  knockoutHeaderBgColor: '',
  knockoutHeaderBorderColor: '',
  knockoutGameBgColor: '',
  knockoutGameBorderColor: '',
  teamLostColor: '',
  pillBackgroundColor: '',
  dropdownBorderColor: '',
  dropdownBtnColor: '',
};

export const tennisRankingTokens = {
  ...pillTabsTokens,
  hiContrast: '',
  primaryBackgroundColor: '',
  rowBackgroundColor: '',
  subHeaderBgColor: '',
  filtersContainerPrimaryBackgroundColor: '',
};

export const tennisSingleEventTokens = {
  ...oddsTokens,
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
  rowBackgroundColor: '',
  scoreAccentColor: '',
};
